<template>
  <v-row>
    <v-col cols="12" v-for="(item, i) in localMilitaryParent.list" :key="i">
      <MilitaryDocComponent
        :index="i"
        :item="item"
        @set-data="setMilitary($event, item)"
        @remove="removeMilitary(item)"
      />
    </v-col>

    <v-col
      cols="12"
      class="d-flex justify-end pt-0"
      v-if="!localMilitaryParent.list.length"
    >
      <v-btn
        color="primary"
        outlined
        rounded
        @click="addMilitary"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Добавить документ о воинской обязанности
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import MilitaryDocComponent from '@/components/zvp/application-create/military-doc/MilitaryDoc'
import {MilitaryParent, Military} from '@/models'
import _cloneDeep from "lodash/cloneDeep";

export default {
  name: "IdentityCardDoc",

  components: {
    Title,
    MilitaryDocComponent
  },

  props: {
    item: MilitaryParent
  },

  data: () => ({
    localMilitaryParent: new MilitaryParent(),
  }),

  computed: {},

  methods: {
    addMilitary() {
      this.localMilitaryParent.list.push(new Military())
    },

    setMilitary(event, item) {
      item.setProperties(event)
      this.$emit('set-data', this.localMilitaryParent)
    },

    removeMilitary(item) {
      this.$emit('remove', item)
      //this.localMilitaryParent.remove(item)
    },
  },

  watch: {
    'item.list': {
      immediate: true,
      deep: true,
      handler(value) {
        this.localMilitaryParent = _cloneDeep(this.item)
        if (!value?.length) this.addMilitary()
      }
    }
  }
}
</script>

<style scoped>
</style>
